'use strict';

export default class EditController {

  /*@ngInject*/
  constructor($http, $state, $stateParams) {
    this.$http = $http;
    this.$state = $state;
    this.$stateParams = $stateParams;
  }

  $onInit() {
    this.getTemplate(this.$stateParams.id);
  }

  getTemplate(id) {
    this.$http.get(`/api/writeTemplates/${id}`).then(res => {
      this.template = res.data;
    });
  }

  update() {
    this.$http.put(`/api/writeTemplates/${this.$stateParams.id}`, this.template).then(res => {
      this.$state.go('writetpl.list');
    });
  }

}



// WEBPACK FOOTER //
// ./client/app/writeTpl/edit/edit.controller.js